<template>
	<vxe-modal v-model="modal" :loading="loading" title="单据明细" width="600" height="400" @show="show" show-footer>
		<template #default>
			<vxe-table ref="detailtable" footer-cell-class-name="footerCellColor" :show-footer="true"
				:footer-method="footerMethod" border show-overflow height="300" :data="tableData">
				<vxe-column type="seq" width="60"></vxe-column>
				<vxe-column field="billCode" title="采购单"></vxe-column>
				<vxe-column field="stockCode" title="入库单"></vxe-column>
				<vxe-column field="storageName" title="仓库"></vxe-column>
				<vxe-column field="debt" title="金额"></vxe-column>
			</vxe-table>
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			tableData: {
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				modal: false,
				loading: false,
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {

			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {
				this.init()
			},
			modalShow() {
				this.modal = true
			},
			footerMethod({
				data
			}) {
				let debt = 0
				data.forEach((item) => {
					debt += item.debt ? parseFloat(item.debt) : 0
				})
				return [
					['合计', '', '', '',debt.toFixed(2)]
				]
			},
			detailExport(data){
				this.$refs.detailtable.exportData({
					data:data,
					type: 'xlsx'
				})
			}
		},
		components: {

		}
	}
</script>